<template>
  <div
    class="modal fade"
    id="AddRssFeedModal"
    tabindex="-1"
    aria-labelledby="AddNewBookModalLabel"
    aria-hidden="true"
  >
    <loading :active="isLoading" :is-full-page="fullPage" :loader="loader" />
    <div class="modal-dialog">
      <div class="modal-content AddNewBookModal_content">
        <div class="modal-header AddNewBookModal_header">
          <h5 class="modal-title" id="AddNewBookModalLabel">
            <img
              src="../../assets/images/left.svg"
              class="me-2"
              width="20"
              height="20"
            />
            Add Audio Book {{channelId}}
          </h5>
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
          ></button>
        </div>
        <form @submit.prevent="processForm">
          <!-- error messages for form validation -->
          <div v-if="errors.length" style="color:white">
            <span style="font-size:15px; margin-top:5px; margin-left:10px;">
                Please correct the following error(s):
            </span>
            <ul  style="font-size:12px;">
              <li v-for="(error, index) in errors" :key="index">{{error}}</li>
            </ul>
          </div>
          <div class="modal-body">
            <div class="mb-3">
              <div class="row align-items-center">
                <div class="col-12 col-md-4">
                  <label class="form-label star_after">Provide RSS Link</label>
                </div>
                <div class="col-12 col-md-8">
                  <input
                    type="text"
                    class="form-control bg-input border-0"
                    v-model="rssLink"
                  />
                </div>
              </div>
            </div>
            
            <div class="mb-3">
              <div class="row align-items-center">
                <div class="col-12 col-md-4">
                  <label class="form-label star_after">Category</label>
                </div>
                <div class="col-12 col-md-8">
                    <select
                    v-model="selectCategoryId"
                    type="text"
                    class="form-select bg-input border-0"
                  >
                    <option value="">Select category</option>
                    <option
                      v-for="(category, index) in categories"
                      :key="index"
                      :value="category.id"
                    >
                      {{ category.name }}
                    </option>
                  </select>
                </div>
              </div>
            </div>
        </div>
        <div class="modal-footer">
        <button
            type="reset"
            class="btn btn-secondary btn-sm"
            data-bs-dismiss="modal"
        >
            Close
        </button>
        <button
            type="submit"
            class="btn btn-primary btn-sm"
        >
            Submit
        </button>
        </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import Loading from "vue-loading-overlay";

export default {
  name: "AddAudioBookModal",
  components: { Loading },
  props:["channelId"],
  data() {
    return {
      errors: [],
      categories: [],
      selectCategoryId: "",
      rssLink: undefined,
      //channelId: localStorage.getItem(this.$channelId),
      //for loader
      isLoading: false,
      fullPage: true,
      loader: "bars",
    };
  },
  methods: {
    isDisabled() {
      return (this.isFree = !this.isFree);
    },
    processForm() {
      if (this.checkForm()) {
        this.submitData();
      }
    },
    checkForm() {
      if (this.rssLink && this.selectCategoryId) {
        return true;
      }
      this.errors = [];
      if (!this.rssLink) {
        this.errors.push("RSS Link required.");
        return false;
      }
      if (!this.selectCategoryId) {
        this.errors.push("Please select Category.");
        return false;
      }
      return false;
    },

    async getData() {
      this.isLoading = true;
      const token = localStorage.getItem(this.$tokenKey);
      const res = await axios.get(
        this.$baseUrl + this.$api + this.$version1 + "/categories",
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );
      if (res.status == 200) {
        this.categories = res.data;
        this.isLoading = false;
      }
    },

    async submitData(n) {
      this.isLoading = true;
      const token = localStorage.getItem(this.$tokenKey);
      const res = await axios.post(
        this.$baseUrl +
          this.$api +
          this.$version2 +
          "/audiobooks/add-from-rss-feed" +
          "?channelId=" +
          this.channelId,
        {
          rssLink: this.rssLink,
          CategoryId: this.selectCategoryId,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );
      this.isLoading = false;
      if (res.status == 200) {
        this.$vToastify.info("Audiobook created. Waiting for Admin Approval");
        this.$router.go();
      }
    },
  },
  mounted() {
    // use this for get
    this.getData();
  },
};
</script>

<style scoped>
</style>
